var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full col-span-full"
  }, [_vm.label ? _c('info-bulle', {
    attrs: {
      "name": 'name',
      "is-libelle-input": true
    },
    scopedSlots: _vm._u([{
      key: "libelleBefore",
      fn: function () {
        return [_c('div', {
          staticClass: "text-sm text-gray-600 truncate mb-2 flex items-center gap-x-1",
          on: {
            "mouseover": function ($event) {
              _vm.tooltipLabel = true;
            },
            "mouseleave": function ($event) {
              _vm.tooltipLabel = false;
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")])];
      },
      proxy: true
    }, {
      key: "tooltipLibelleBefore",
      fn: function () {
        return [_c('transition', {
          attrs: {
            "enter-active-class": "duration-300 delay-1000",
            "enter-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "duration-300",
            "leave-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }
        }, [_vm.tooltipLabel && _vm.label ? _c('div', {
          staticClass: "absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
        }, [_vm._v("\n          " + _vm._s(_vm.label) + "\n        ")]) : _vm._e()])];
      },
      proxy: true
    }], null, false, 3792624581)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative h-full"
  }, [_c('div', {
    staticClass: "border border-opacity-50 rounded-md block w-full appearance-none sm:leading-5 truncate border-indigo-600 bg-gray-200 cursor-not-allowed text-sm px-3 py-2 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4",
    class: {
      'h-full': _vm.growsVertically
    },
    on: {
      "mouseover": function ($event) {
        _vm.showToolTip = true;
      },
      "mouseleave": function ($event) {
        _vm.showToolTip = false;
      }
    }
  }, [_vm._l(_vm.valueComp, function (val, i) {
    return _c('span', {
      key: `${val.newValue}${i}`,
      class: {
        'text-teal-600': val.action === 'added',
        'text-indigo-600': val.action === 'updated',
        'text-pink-600': val.action === 'deleted',
        'text-gray-600': val.action === 'none'
      }
    }, [_vm._v("\n        " + _vm._s(_vm.display(val))), i + 2 <= _vm.valueComp.length ? _c('span', [_vm._v(",")]) : _vm._e()]);
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "duration-300 delay-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.showToolTip && _vm.valueAsStr.length > 0 ? _c('div', {
    staticClass: "absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-128"
  }, [_vm._v("\n          " + _vm._s(_vm.valueAsStr) + "\n        ")]) : _vm._e()])], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }